import LoadingDots from 'components/LoadingDots';
import React, { memo } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { generatePathnameWithLangCode, getPath } from 'utils/RouteHelper';
import { useUser } from '~/authentication/store';
import { useLang } from '~/stores/i18n';

const RedirectRoute = memo(
  () => {
    const lang = useLang();
    const searchParams = new URLSearchParams();
    searchParams.set('returnTo', getPath());
    console.log('url$ rendering redirect route');
    return (
      <Redirect
        to={{
          pathname: generatePathnameWithLangCode('/signup/', lang),
          search: searchParams.toString(),
          state: {
            modal: true,
          },
        }}
      />
    );
  },
  () => true,
);

type PrivateRouteProps = RouteProps;

const PrivateRoute = ({ component, path, ...props }: PrivateRouteProps) => {
  const { isLoggedIn, loading } = useUser();
  console.log('url$ PrivateRoute', isLoggedIn, loading, component);

  if (loading) {
    return <LoadingDots />;
  }

  if (!isLoggedIn && !loading) {
    return <RedirectRoute />;
  }

  const FinalComponent = isLoggedIn ? component : RedirectRoute;

  return (
    <Route path={path}>
      <FinalComponent {...props} />
    </Route>
  );
};

export default PrivateRoute;
